import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipComponent } from '@components/tooltip/tooltip.component';
import { BreadcrumbComponent, IMTBreadcrumbConfig } from '../breadcrumb/breadcrumb.component';
import { HeaderTabsComponent } from "../header-tabs/header-tabs.component";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ui-unified-page-header',
    imports: [
    FormsModule,
    BreadcrumbComponent,
    TooltipComponent,
    CommonModule
],
    templateUrl: './unified-page-header.component.html',
    styleUrl: './unified-page-header.component.scss'
})
export class UnifiedPageHeaderComponent {
  @Input() breadcrumbConfigs?: IMTBreadcrumbConfig[];
  @Input() pageTitle: string;
  @Input() boldedText?: string;
  @Input() details?: string;
  @Input() tooltipContent?: string;
  @Input() hideBottom = false; // if need to put some compoenent at bottom of header
}
